import React, { useState, useEffect } from 'react';
import {
  AppBar, Toolbar, Box, Button, IconButton, Drawer,
  List, ListItem, ListItemText, Container, useScrollTrigger,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

const navLinks = ['Features', 'How It Works', 'Pricing', 'Testimonials'];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id.toLowerCase().replace(/\s/g, '-'))?.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: scrolled ? 'rgba(255,255,255,0.92)' : 'transparent',
          backdropFilter: scrolled ? 'blur(20px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(16,117,186,0.1)' : 'none',
          transition: 'all 0.4s ease',
        }}
      >
        <Container maxWidth="lg">
          <Toolbar sx={{ py: 1, px: '0 !important', justifyContent: 'space-between' }}>
            {/* Logo */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {/* <Box
                sx={{
                  width: 38, height: 38, borderRadius: '10px',
                  background: 'linear-gradient(135deg, #1075BA 0%, #3a9de4 100%)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: '0 4px 15px rgba(16,117,186,0.4)',
                }}
              >
                <DirectionsCarIcon sx={{ color: '#fff', fontSize: 20 }} />
              </Box> */}
              <Box sx={{ fontWeight: 800, fontSize: '1.25rem', color: '#0d1f35', letterSpacing: '-0.02em' }}>
                Auto<Box component="span" sx={{ color: '#1075BA' }}>Checker</Box>
              </Box>
            </Box>

            {/* Desktop links */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 0.5 }}>
              {navLinks.map((link) => (
                <Button
                  key={link}
                  onClick={() => scrollTo(link)}
                  sx={{ color: '#0d1f35', fontWeight: 600, px: 2, '&:hover': { color: '#1075BA', bgcolor: 'rgba(16,117,186,0.06)' } }}
                >
                  {link}
                </Button>
              ))}
              <Button
                variant="contained"
                sx={{
                  ml: 2,
                  background: 'linear-gradient(135deg, #1075BA 0%, #3a9de4 100%)',
                  boxShadow: '0 4px 20px rgba(16,117,186,0.35)',
                  '&:hover': { boxShadow: '0 6px 25px rgba(16,117,186,0.5)', transform: 'translateY(-1px)' },
                  transition: 'all 0.2s ease',
                }}
              >
              Book a Demo
              </Button>
            </Box>

            <IconButton sx={{ display: { md: 'none' }, color: '#0d1f35' }} onClick={() => setMobileOpen(true)}>
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}
        PaperProps={{ sx: { width: 280, p: 3 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <IconButton onClick={() => setMobileOpen(false)}><CloseIcon /></IconButton>
        </Box>
        <List>
          {navLinks.map((link) => (
            <ListItem key={link} onClick={() => scrollTo(link)} sx={{ cursor: 'pointer', borderRadius: 2, mb: 1, '&:hover': { bgcolor: 'rgba(16,117,186,0.06)' } }}>
              <ListItemText primary={link} primaryTypographyProps={{ fontWeight: 600 }} />
            </ListItem>
          ))}
          <ListItem sx={{ mt: 2 }}>
            <Button fullWidth variant="contained" sx={{ background: 'linear-gradient(135deg, #1075BA, #3a9de4)' }}>
                Book a Demo
            </Button>
          </ListItem>
        </List>
      </Drawer>
    </>
  );
}
